/* Kingholm theme: kleine, afhankelijkheidsvrije scripts */
(function () {
  'use strict';

  // Mobiel menu
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var header = toggle.closest('.header');
    var open = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Dropdowns sluiten bij klik buiten
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-autoclose][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-autoclose][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  // Sorteren in collecties
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Hoeveelheid knoppen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = btn.dataset.qty === 'plus' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Productgalerij
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-main-image]');
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset || '';
    main.alt = thumb.dataset.alt || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  // Variantkeuze
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var noDec = Math.round(cents / 100).toString();
    return (format || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec);
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function update() {
      var opts = selected();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      root.querySelectorAll('[data-option-label]').forEach(function (l, i) { l.textContent = opts[i] || ''; });
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Niet beschikbaar';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht';
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.money_format);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, data.money_format);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (variant.featured_image) {
        var thumb = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Toevoegen...';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1 }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || 'Fout');
        addBtn.textContent = 'Toegevoegd';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        var msg = root.querySelector('[data-cart-message]');
        if (msg) { msg.hidden = false; }
        setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
      }).catch(function (err) {
        addBtn.textContent = original;
        addBtn.disabled = false;
        var msg = root.querySelector('[data-cart-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      });
    });
  }

  document.querySelectorAll('[data-product]').forEach(initProduct);

  // Productaanbevelingen
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });
})();
